<template>
  <el-cascader
    v-model="selectedValue"
    :options="regionOptions"
    :props="cascaderProps"
    :placeholder="placeholder"
    :style="{ width: width }"
    :disabled="disabled"
    clearable
    filterable
    @change="handleChange"
  />
</template>

<script>
import api from '@/services/api';

export default {
  name: 'RegionCascader',
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请选择省市区'
    },
    width: {
      type: String,
      default: '100%'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    checkStrictly: {
      type: Boolean,
      default: false
    },
    expandTrigger: {
      type: String,
      default: 'hover'
    }
  },
  data() {
    return {
      selectedValue: '',
      regionOptions: [],
      regionData: [],
      cascaderProps: {
        expandTrigger: this.expandTrigger,
        checkStrictly: this.checkStrictly,
        emitPath: false,
        value: 'code',
        label: 'name',
        children: 'children'
      }
    };
  },
  watch: {
    value: {
      handler(newVal) {
        this.selectedValue = newVal || '';
      },
      immediate: true
    }
  },
  created() {
    this.loadRegionData();
  },
  methods: {
    async loadRegionData() {
      try {
        const res = await api.post('/dictionary', { tags: ['REGION'] });
        if (res.data.success) {
          this.regionData = res.data.data.REGION || [];
          this.regionOptions = this.buildRegionCascader(this.regionData);
        }
      } catch (e) {
        console.error('加载地区数据失败', e);
      }
    },
    buildRegionCascader(items) {
      const provinces = items.filter(item => !item.parent_code && !item.parentCode);
      return provinces.map(province => {
        const cities = items.filter(item => (item.parent_code || item.parentCode) === province.code);
        return {
          code: province.code,
          name: province.name,
          children: cities.length > 0 ? cities.map(city => {
            const districts = items.filter(item => (item.parent_code || item.parentCode) === city.code);
            return {
              code: city.code,
              name: city.name,
              children: districts.length > 0 ? districts.map(district => ({
                code: district.code,
                name: district.name
              })) : undefined
            };
          }) : undefined
        };
      });
    },
    handleChange(value) {
      this.$emit('input', value);
      this.$emit('change', value);
    },
    getRegionName(code) {
      if (!code) return '';
      const item = this.regionData.find(r => r.code === code);
      return item ? item.name : '';
    },
    getFullPath(code) {
      if (!code) return [];
      const result = [];
      let current = this.regionData.find(r => r.code === code);
      while (current) {
        result.unshift({ code: current.code, name: current.name });
        const parentCode = current.parent_code || current.parentCode;
        current = parentCode ? this.regionData.find(r => r.code === parentCode) : null;
      }
      return result;
    },
    getFullPathNames(code) {
      const path = this.getFullPath(code);
      return path.map(p => p.name).join('-');
    },
    getRegionData() {
      return this.regionData;
    },
    setValue(code) {
      this.selectedValue = code || '';
    },
    /**
     * 从字典备注中解析区号。备注格式：城市（区号：0556）
     * 从当前节点向根节点查找，返回第一个包含区号的备注中的区号
     */
    getAreaCode(code) {
      if (!code) return '';
      let current = this.regionData.find(r => r.code === code);
      while (current) {
        const remark = current.remark || '';
        const match = remark.match(/区号[：:]\s*([^）)]+)/);
        if (match) return String(match[1]).trim();
        const parentCode = current.parent_code || current.parentCode;
        current = parentCode ? this.regionData.find(r => r.code === parentCode) : null;
      }
      return '';
    }
  }
};
</script>
